import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { NotificationManager } from "react-notifications";
import store from "../../store";
import { Loader } from "../../components/loader";
import Select from "react-select";
import { forceInputUppercase } from "../../utils/helper";
import AvatarEditor from 'react-avatar-editor';
import Slider from 'react-rangeslider';
import 'react-rangeslider/lib/index.css';
import { createFoodType , updateFoodType } from "../../actions/foodType";

const $ = window.$;

class FoodType extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            title : '',
            imgSrc : '',
            imgName : '',
            zoom: 1,
            rotate: 0,
            editor: '',
            loading: false,
            inputNotValid: false,
            foodTypeId : null ,
            affiliateLink : "",
            avatarPath : "", 
            avatarFileName : "",
            editImage : false ,
          };      
}

  closeModal = () => {
    $("#add_breed_food").modal("hide");
    this.resetState();
    this.props.actionFoodType();
  };

  resetState = () => {
    document.getElementById('imgSrc').value = "";
    this.setState({
        foodTypeId : null ,
        title : "",
        affiliateLink : "",
        imgSrc : "",
        imgName : "",
        avatarPath : "",
        avatarFileName : "",
        loading: false,
        inputNotValid: false ,
    });
  };

  urlPatternValidation = URL => {
    const regex = new RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');    
    return regex.test(URL);
  };

  _onChange = () => {
    // Assuming only image
    var file = this.refs.file.files[0];
    var reader = new FileReader();
    var url = reader.readAsDataURL(file);
  
     reader.onloadend = function (e) {
        this.setState({
            imgSrc: reader.result,
            imgName: file.name
        })
      }.bind(this);
    // Would see a path?
    // TODO: concat files
  }

  setEditorRef = (editor) => {
    if(editor) {
      this.setState({editor: editor});
    }
  }

  changeZoom = (val) => {
    if(val) {
        this.setState({zoom: val})
    }
  }

  changeRotate = () => {
    var nr = parseInt(this.state.rotate) + 90;
    if(nr >= 360) nr = 0;
    this.setState({rotate: nr});
  }

  submitBreedFood(e) {
    var image = '';
    this.setState({ loading: true });
    if(this.state.editor && this.state.imgSrc) {
        image = this.state.editor.getImageScaledToCanvas().toDataURL("image/jpeg");
    }
    let data = {
        title: this.state.title,
        avatar: image,
        avatar_title: this.state.imgName,
        affiliate_link : this.state.affiliateLink,
        PetShopId: this.props.petShop.currentPetshop.id,
    };

      if (this.state.title && this.state.title.length > 0 
        && this.state.imgName && this.state.imgName.length > 0 
        && this.state.affiliateLink && this.state.affiliateLink.length > 0) {
          if(!this.urlPatternValidation(this.state.affiliateLink)){
            e.preventDefault();
            NotificationManager.warning("Inavlid affliate link");
            this.setState({ loading: false, inputNotValid: true });
          }else{            
            if(this.state.foodTypeId){
              data.id = this.state.foodTypeId;
              this.props.updateFoodType(data);     
              this.props.actionFoodType();   
            }else{
              this.props.createFoodType(data);
            }    
          }          
      } else {
        e.preventDefault();
        NotificationManager.warning("Incomplete information");
        this.setState({ loading: false , inputNotValid: true });
      }
  }

  handleChange = event => {
    if (event.target.name !== "affiliateLink") {
      forceInputUppercase(event);
    } 
    const value = event.target.value;
    this.setState({
      ...this.state,
      [event.target.name]: value
    });
  };

  componentWillReceiveProps = nextProps => {
    
    if (nextProps.selectedFoodTypeData 
            && nextProps.selectedFoodTypeData.id
            && nextProps.selectedFoodTypeData.id !== this.state.foodTypeId ) {    
             this.setState({
              foodTypeId : nextProps.selectedFoodTypeData.id,
              title : nextProps.selectedFoodTypeData.title,
              affiliateLink : nextProps.selectedFoodTypeData.affiliate_link,
              avatarPath : nextProps.selectedFoodTypeData.avatar_path,
              avatarFileName : nextProps.selectedFoodTypeData.avatar_file_name,
              imgName : nextProps.selectedFoodTypeData.avatar_file_name
              }, () => {               
                $("#add_breed_food").modal("show");
             });
          }
      
    if (nextProps.foodType && this.props.foodType !== nextProps.foodType) {
      this.resetState();
      NotificationManager.success("Breed Category Added");
      $("#add_breed_food").modal("hide");
    }

    if (nextProps.foodTypeUpdated && this.props.foodTypeUpdated  !== nextProps.foodTypeUpdated) {
      this.resetState();
      NotificationManager.success("Breed Food Type Updated");
      $("#add_breed_food").modal("hide");
    }

    if(nextProps.setFoodTypeError && this.props.setFoodTypeError !== nextProps.setFoodTypeError){
      if(nextProps.setFoodTypeError.details.message && nextProps.setFoodTypeError.details.message == "Food type already exists"){
        this.setState({ loading: false });
        NotificationManager.error("Food type already exists");    
      }
    }

    if(nextProps.updateFoodTypeError && this.props.updateFoodTypeError !== nextProps.updateFoodTypeError){
      if(nextProps.updateFoodTypeError.details.message && nextProps.updateFoodTypeError.details.message == "Food type already exists"){
        this.setState({ loading: false });
        NotificationManager.error("Food type already exists");    
      }
    }
  }

render() {
    const { PetId, toa } = this.state;
    return (
        <div
        className="modal fade show"
        id="add_breed_food"
        tabIndex="-1"
        role="dialog"
      >
           <div className="modal-dialog" role="document">
          <div className="modal-content">
            <form className="m-form">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  {!this.state.foodTypeId  ? "Add new food type " : "Edit food type"}
                </h5>
                <button
                  type="button"
                  className="close"
                  onClick={this.closeModal}
                  aria-label="Close"
                >
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div className="modal-body">
                <div className="row">
                  <div className="col-xl-12">
                    <div className="m-form__section m-form__section--first">
                     <div className="form-group m-form__group row">
                        <label className="col-xl-3 col-lg-3 col-form-label">
                             Title
                          </label>
                          <div className="col-xl-9 col-lg-9">
                          <textarea className="form-control m-input m-input--air" type="text"
                            name="title"                         
                            value={this.state.title}
                            onChange={e => this.handleChange(e)}
                            placeholder=""
                             rows="3">                             
                             </textarea>
                          <span
                            className={
                              this.state.inputNotValid && this.state.title.length === 0
                                ? "m-form__help_danger"
                                : "m-form__help"
                            }
                          >
                            Please enter title
                            </span>
                          </div>
                        </div>
                        <div className="form-group m-form__group row">
                            <label className="col-xl-3 col-lg-3 col-form-label">Upload Image</label>                           
                                <div className="col-xl-9 col-lg-9 pt-3">
                                  <input 
                                      ref="file"
                                      type="file"
                                      id="imgSrc"
                                      accept="image/*" 
                                      name="imgSrc"
                                      onChange={this._onChange}/>
                                      <br/>                        
                                </div>                                                     
                          </div>
                          {
                              this.state.foodTypeId && this.state.avatarPath.length > 0 && this.state.avatarFileName.length > 0 && !this.state.imgSrc &&
                              <div className="form-group m-form__group row pt-0">
                                <div className="col-xl-3 col-lg-3">
                                </div>
                                <div className="col-xl-9 col-lg-9">
                                  <img
                                    src={
                                    process.env.REACT_APP_S3_PATH +
                                    "/" +
                                    this.state.avatarPath + "/" + this.state.avatarFileName
                                    }
                                    style={{ maxWidth: "120px", marginBottom: "5px" }}
                                    alt=""
                                  />
                                </div>  
                              </div>
                          }
                          {this.state.imgSrc && 
                            <div className="form-group m-form__group row justify-content-md-center m--align-center pt-0">
                                <div className="col-xs-10 col-md-4 offset-md-2">
                                  <div className="row">
                                    <div className="col-xs-12 col-sm-12">
                                      <AvatarEditor
                                          ref={this.setEditorRef}
                                          image={this.state.imgSrc}
                                          border={0}
                                          width={200}
                                          height={200}
                                          borderRadius={100}
                                          color={[0, 0, 0, 0.6]} // RGBA
                                          scale={this.state.zoom}
                                          rotate={this.state.rotate}
                                      />
                                    </div>
                                  </div>
                                  <div className="row justify-content-md-center m--align-center">
                                    <div className="col-xs-12 col-sm-12">
                                      <button type="button" className="btn btn-primary m-btn m-btn--icon m-btn--icon-only m-btn--pill" onClick={this.changeRotate}>
                                        <i className="la la-rotate-right"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-xs-2 col-md-4 d-none d-sm-none d-md-block">
                                    <div className='slider orientation-reversed'>
                                        <div className='slider-group'>
                                            <div className='slider-vertical'>
                                                <Slider
                                                    min={1}
                                                    max={5}
                                                    step={0.1}
                                                    tooltip={false}
                                                    value={this.state.zoom}
                                                    orientation='vertical'
                                                    onChange={this.changeZoom}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-2 col-md-4 d-block d-sm-block d-md-none d-lg-none">
                                   
                                            <Slider
                                                min={1}
                                                max={5}
                                                step={0.1}
                                                tooltip={false}
                                                value={this.state.zoom}
                                                onChange={this.changeZoom}
                                            />
                                         
                                </div>
                            </div>
                          }
                           
                       <div className="form-group m-form__group row">
                        <label className="col-xl-3 col-lg-3 col-form-label">
                            Affiliate Link 
                          </label>
                          <div className="col-xl-9 col-lg-9">
                          <textarea className="form-control m-input m-input--air"                          
                            type="text"
                            name="affiliateLink"  
                            value={this.state.affiliateLink}
                            onChange={e => this.handleChange(e)}                                                 
                            placeholder=""
                             rows="3">

                             </textarea>
                          <span
                            className={
                              this.state.inputNotValid && this.state.affiliateLink.length === 0 
                                ? "m-form__help_danger"
                                : "m-form__help"
                            }
                          >
                            Please enter affiliate link
                            </span>
                          </div>
                        </div>
                       
                    </div>
                   </div>
                </div>
            </div>   
            <div className="modal-footer">
            {this.state.loading == false ? (
                  <div>
                    <button
                      type="button"
                      className="btn btn-secondary m-btn--pill mx-2"
                      onClick={this.closeModal}
                    >
                      Close
                      </button>
                    <button
                      onClick={(e) => this.submitBreedFood(e)}
                      type="submit"
                      className="btn btn-primary m-btn--pill"
                    >
                      Submit
                      </button>
                  </div>
                ) : (
                    <div className="center-row">
                      <Loader size={50} />
                    </div>
                  )}
            </div>     
        </form>
        </div>
        </div>
      </div>
    )
}

}

const mapStateToProps = state => ({
    petShop: state.petShopReducer,
    foodType: state.foodTypeReducer.setFoodType,
    foodTypeUpdated : state.foodTypeReducer.updateFoodType,
    setFoodTypeError : state.foodTypeReducer.setFoodTypeError,
    updateFoodTypeError : state.foodTypeReducer.updateFoodTypeError,
  });
  
  const mapDispatchToProps = dispatch => ({
    createFoodType: data => {
      dispatch(createFoodType(data));
    },

    updateFoodType : data => {
      dispatch(updateFoodType(data));
    },

  });
  
  export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(FoodType)
  );